import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 10 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 11\" id=\"icon-play\"><path d=\"M10 5.5 1 11V0l9 5.5Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol